import RestClient from '../../RestClient/RestClient';
import { getCookie } from '../../helpers/Cookies';
import { populateRegionalPricesInSuggestionProducts } from '../../helpers/RegionalPriceHelper';
import EndecaSearchApiConstants from './EndecaSearchApiConstants';
import { getHostConfig } from '../../Common/RestConfig';
import { apiHosts } from '../../RestClient/FetchHelper.config';

const getSearchResultURL = (searchTerm) =>
    EndecaSearchApiConstants.ENDECASEARCH_RESULT_URL + searchTerm;

const getDepartment = (suggestion, params, disableNewAutoSuggestion) => {
    let department = '';
    if (
        disableNewAutoSuggestion &&
        params &&
        params.channel === EndecaSearchApiConstants.CHANNEL.MOBILE
    ) {
        department = suggestion.departments;
        return department;
    }
    if (suggestion.subTermSuggestions) {
        department = suggestion.subTermSuggestions.map((subterm) => ({
            name: subterm.department || '',
            href: subterm.departmentURL || '',
            products: subterm.products || [],
        }));
    }
    return department;
};
const getData = (json, channel, disableNewAutoSuggestion) => {
    if (disableNewAutoSuggestion) {
        if (channel === EndecaSearchApiConstants.CHANNEL.DESKTOP) {
            return json.data[0].termsuggestions;
        }
        if (channel === EndecaSearchApiConstants.CHANNEL.TABLET) {
            return json.data.termsuggestions;
        }
        return json.data.suggestions;
    }
    return json.data[0].termsuggestions;
};
export const getSearchResults = (
    params = {},
    regionZone,
    version = '/v3',
    disableNewAutoSuggestion
) => {
    if (disableNewAutoSuggestion) {
        version = '/v1';
    }
    const shipToCountry =
        getCookie('shipToCountry') || EndecaSearchApiConstants.DEFAULT_SHIP_TO_COUNTRY;
    params.shipToCountry = shipToCountry;
    let config = {
        url: EndecaSearchApiConstants.SEARCH_URL,
        version,
        params,
        apiHost: apiHosts.search,
    };
    config = getHostConfig(config);

    return RestClient.get(config)
        .then((json) => {
            const data = getData(json, params.channel, disableNewAutoSuggestion);
            data.status = 200;
            return data.map((suggestion) => {
                if (suggestion.products && regionZone) {
                    populateRegionalPricesInSuggestionProducts(suggestion.products, regionZone);
                }
                return {
                    term: suggestion.term,
                    url: suggestion.url,
                    depts: getDepartment(suggestion, params, disableNewAutoSuggestion),
                    products: suggestion.products,
                };
            });
        })
        .catch((error) => ({
            status: 500,
            error,
        }));
};

export const getSearchDetailResult = (searchTerm) =>
    RestClient.get(getSearchResultURL(searchTerm))
        .then((json) => ({
            status: 200,
            query: json.data.query,
            standardizedQuery: json.data.standardizedQuery,
            count: json.data.count.toString(),
            redirectUrl: json.data.redirectUrl,
        }))
        .catch((error) => ({
            status: 500,
            error,
        }));
